import { render } from "./DocumentText.svg?vue&type=template&id=05e2bf7a"
const script = {}
script.render = render

export default script